import React, { useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const getData = (sensores) => {

    const corriente = sensores.map(item => item.corriente);
    const tension = sensores.map(item => item.tension);
    const potencia = sensores.map(item => item.potencia);
    const hora = sensores.map(item => item.fecha);

    return {
        labels: hora,
        datasets: [
            {
                label: 'Current',
                data: corriente,
                borderColor: 'rgb(220, 20, 60)',
                backgroundColor: 'rgba(220, 20, 60, 0.5)',
            },
            {
                label: 'Voltage',
                data: tension,
                borderColor: 'rgb(65, 105, 225)',
                backgroundColor: 'rgba(65, 105, 225, 0.5)',
            },
            {
                label: 'Power',
                data: potencia,
                borderColor: 'rgb(255, 255, 0)',
                backgroundColor: 'rgba(255, 255, 0, 0.5)',
            }
        ],
    };
};

const getOptions = () => ({
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Relation Tesla node',
        },
    },
});

const ChartTesla = ({ data, chartId }) => {
    const chartRef = useRef(null);

    return (
        <Line
            id={`chart-${chartId}`}
            key={chartId}
            ref={chartRef}
            data={getData(data)}
            options={getOptions()}
        />
    );
};

export default ChartTesla;
